export async function shareInviteLink({
  inviteLink,
  roomTitle = "",
  navigatorImpl = typeof navigator !== "undefined" ? navigator : null,
  clipboardImpl =
    typeof navigator !== "undefined" && navigator.clipboard ? navigator.clipboard : null,
} = {}) {
  const link = String(inviteLink || "").trim();
  if (!link) throw new Error("invite_link_required");

  const text = roomTitle
    ? `Entre na sala "${roomTitle}" do Van Helsin Chat.`
    : "Entre na sala do Van Helsin Chat.";

  if (navigatorImpl && typeof navigatorImpl.share === "function") {
    await navigatorImpl.share({
      title: "Van Helsin Chat",
      text,
      url: link,
    });
    return { method: "share" };
  }

  if (clipboardImpl && typeof clipboardImpl.writeText === "function") {
    await clipboardImpl.writeText(link);
    return { method: "clipboard" };
  }

  throw new Error("share_unavailable");
}
